"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipContentTextProperty = exports.tipContentTextPropertyDefinition = void 0;
exports.tipContentTextPropertyDefinition = {
    view: { label: 'Tip' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 120,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'tip-content-text',
};
const isTipContentTextProperty = (prop) => {
    return prop.name === exports.tipContentTextPropertyDefinition.name;
};
exports.isTipContentTextProperty = isTipContentTextProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLWNvbnRlbnQtdGV4dC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RpcC1jb250ZW50LXRleHQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFO0lBQ3RCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEdBQUc7U0FDZDtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxrQkFBa0I7Q0FDTyxDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=